
import respUtility from '@/mixins/respUtility';
import ReviewsViewTabSectionTopContentWriteReviewForm from './TopContent/WriteReviewForm.vue';
import ReviewsViewTabSectionTopContentSuccessMessage from './TopContent/SuccessMessage.vue';

export default {
  name: 'ReviewsViewTabSectionTopContent',
  mixins: [respUtility],
  components: {
    ReviewsViewTabSectionTopContentWriteReviewForm,
    ReviewsViewTabSectionTopContentSuccessMessage,
  },
  data() {
    return {
      showPopup: false,
      showSuccessPopup: false,
      defaultButtonAttr: {
        large: true,
      },
    };
  },
  watch: {
    showPopup(value) {
      this.$nextTick(() => {
        const htmlElement = document.querySelector('html');
        if (value) {
          htmlElement.classList.add('global-scroll-disable');
        } else {
          htmlElement.classList.remove('global-scroll-disable');
        }
      });
    },
    showSuccessPopup(value) {
      this.$nextTick(() => {
        const htmlElement = document.querySelector('html');
        if (value) {
          htmlElement.classList.add('global-scroll-disable');
        } else {
          htmlElement.classList.remove('global-scroll-disable');
        }
      });
    },
  },
  methods: {
    openPopup() {
      this.showPopup = true;
      this.$nuxt.$emit('change-global-scrolling', !this.showPopup);
    },
    closePopup() {
      this.showPopup = false;
      this.$nuxt.$emit('change-global-scrolling', !this.showPopup);
    },
    onSubmit() {
      this.showSuccessPopup = true;
      this.showPopup = false;
    },
    togglePopup() {
      this.showSuccessPopup = !this.showSuccessPopup;
      this.$nuxt.$emit('change-global-scrolling', !this.showSuccessPopup);
    },
  },
  beforeDestroy() {
    const htmlElement = document.querySelector('html');
    htmlElement.classList.remove('global-scroll-disable');
  },
};
